exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".login-form {\n  padding: 3rem;\n  margin: auto;\n}\n\n@media only screen and (max-width: 600px) {\n  .login-form {\n    padding: 0rem;\n  }\n}", ""]);

